import {createSelector} from "reselect"
import initialState from "./initialState"
import {getCostProjection} from "../../modules"

// SELECTORS
export const getJurisdictions = (state) =>
  getCostProjection(state).jurisdictions

// 1
export const getCountries = createSelector(
  getJurisdictions,
  (jurisdictions) => jurisdictions.countries
)

export const getFilingStatuses = createSelector(
  getJurisdictions,
  (jurisdictions) => jurisdictions.filingStatuses
)

export const getJurisdictionsPayload = createSelector(
  getJurisdictions,
  (jurisdictions) => jurisdictions.jurisdictions
)

// 2
export const getFilingStatusTypes = createSelector(
  getFilingStatuses,
  (filingStatuses) => {
    const results = {}

    filingStatuses.forEach((filingStatus) => {
      if (!results[filingStatus.value]) {
        results[filingStatus.value] = filingStatus.label
      }
    })

    return results
  }
)

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
